import { useCallback, useMemo } from 'react';
import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import { UNFILED_ASSETS_ID } from '../constants/folders';
export default function useCurrentFolderId() {
  const {
    folderId
  } = useCrmObjectType();
  const resolvedFolderId = useMemo(() => {
    if (!folderId) {
      return UNFILED_ASSETS_ID;
    }
    const intFolderId = Number(folderId);
    return intFolderId > 0 ? intFolderId : UNFILED_ASSETS_ID;
  }, [folderId]);
  return resolvedFolderId;
}
export function useSetCurrentFolderId() {
  const {
    onSetFolderId
  } = useCrmObjectType();
  return useCallback(folderId => {
    onSetFolderId(folderId);
  }, [onSetFolderId]);
}